import { IGetGradesResponse } from '../../interface/studentModel';
import {
  IGetTeacherByIdResponseBody,
  IGetTeacherDetailsRequestParams,
  IGetTeachersResponseBody,
  IEditTeacherProfileRequestBody,
  ICreateTeacherRequestBody,
  ICreateTeacherResponseBody,
  ITeacherProfileResponseData,
  IGetAssetId,
} from '../../interface/teacherModel';
import api from '../api';
import apiMultipart, { requests } from '../api-multipart';

export const getTeacherData = async (
  params: IGetTeacherDetailsRequestParams,
): Promise<IGetTeachersResponseBody> => {
  try {
    const response = await api.get<IGetTeachersResponseBody>(
      `/teacher?perPageRow=${params.perPageRow}&currentPage=${params.currentPage}${params.grade}${params.medium}${params.search}`,
    );
    return response.data;
  } catch (error: any) {
    console.error(error, 'Error fetching teacher data');
    throw new Error(` ${error.message}`);
  }
};
export const createTeacher = async (
  data: ICreateTeacherRequestBody,
): Promise<ICreateTeacherResponseBody> => {
  try {
    // Sending POST request to '/teacher' endpoint with the request body
    const response = await api.post<ICreateTeacherResponseBody>('/teacher', data);
    // Return the response data
    return response.data;
  } catch (error: any) {
    // Logging the error and throwing it with a meaningful message
    console.error(error, 'Error creating teacher');
    throw new Error(error.message);
  }
};

export const getAssetId = async (
  file: FormData,
  onUploadProgress?: (percent: number) => void,
): Promise<IGetAssetId> => {
  try {
    const response = await apiMultipart.post<IGetAssetId>('/file', file, {
      onUploadProgress: onUploadProgress
        ? (event) => {
            // event.total can be undefined for some browsers/proxies; guard against it.
            if (event.total) {
              onUploadProgress(Math.round((event.loaded * 100) / event.total));
            }
          }
        : undefined,
    });
    return response.data;
  } catch (error: any) {
    console.error(error, 'Error getting asset id');
    throw new Error(`Failed to get asset id: ${error.message}`);
  }
};

export const getTeacherDataByID = async (id: string): Promise<IGetTeacherByIdResponseBody> => {
  try {
    const response = await api.get<IGetTeacherByIdResponseBody>(`/teacher/${id}`);
    return response.data;
  } catch (error: any) {
    console.error(error, 'Error fetching teacher data');
    throw new Error(`Failed to fetch teacher data: ${error.message}`);
  }
};
export const deleteTeacherDataByID = async (id: string): Promise<IGetTeacherByIdResponseBody> => {
  try {
    const response = await api.delete<IGetTeacherByIdResponseBody>(`/teacher/${id}`);
    return response.data;
  } catch (error: any) {
    console.error(error, 'Error fetching teacher data');
    throw new Error(`Failed to fetch teacher data: ${error.message}`);
  }
};

export const putEditTeacher = async (
  id: string,
  requestBody: ICreateTeacherRequestBody,
): Promise<IGetTeacherByIdResponseBody> => {
  try {
    const response = await api.put<IGetTeacherByIdResponseBody>(`/teacher/${id}`, requestBody);
    return response.data;
  } catch (error: any) {
    console.error(error, 'Error posting teacher data');
    throw new Error(error.message);
  }
};
